// extracted by mini-css-extract-plugin
export default {"rounded_check_input_label":"RoundCheckInput_rounded_check_input_label__RHpJq","new_checkbox":"RoundCheckInput_new_checkbox__+Xmxp"};